import React, { useState } from "react";
import { TimedText } from "@energy-advice/alertfan-api-client";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { DweenTimeUnitEnum, fmtDateUntilUnit } from "utils/time-utils";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { T } from "services/lang/LanguageService";
import { useTimezone } from "../../../hooks/useTimezone";

type TransposedArrayTableType = {
  properties: Array<TimedText>;
};

const TransposedArrayTable = ({ properties }: TransposedArrayTableType) => {
  const tz = useTimezone();
  const [dialog, setDialog] = useState(false);

  return (
    <>
      {properties && properties.length > 0 && (
        <Button
          icon="pi pi-bars"
          tooltip={T("word.previous-texts")}
          className="p-button-sm"
          onClick={() => setDialog(true)}
        />
      )}
      {dialog && (
        <Dialog
          onHide={() => setDialog(false)}
          visible={dialog}
          header={T("word.previous-texts")}
          style={{ width: "400px" }}
        >
          <DataTable value={properties} removableSort size="small">
            <Column
              header={T("word.time")}
              body={(e: TimedText) =>
                e.time ? fmtDateUntilUnit(new Date(e.time), DweenTimeUnitEnum.SECONDS, tz.display) : "-"
              }
              style={{ whiteSpace: "nowrap" }}
            />
            <Column header={T("word.text")} field="text" />
          </DataTable>
        </Dialog>
      )}
    </>
  );
};

export default TransposedArrayTable;
